import $ from 'jquery'
import _ from 'lodash'
import store from '@/store'
import localizationService from '@/core/services/localization-service'

const baseUrl = process.env.VUE_APP_API_BASE_URL
const apiPath = '/api/v1'
const fullApiPath = baseUrl + apiPath

function getDefaultAjaxSettings() {
  const defaultSettings = { cache: false, data: getDefaultQueryParams() }
  const accessToken = _.get(store, 'getters.authenticationData.accessToken')

  if (accessToken) {
    defaultSettings.headers = { Authorization: `Bearer ${accessToken}` }
  }

  return defaultSettings
}

function ajax(settings) {
  let ajaxSettings = _.merge({}, getDefaultAjaxSettings(), settings)
  return $.ajax(ajaxSettings)
}

function getUrlWithQueryParams(path) {
  const params = getDefaultQueryParams()
  return `${fullApiPath}/${path}?${params}`
}

function getDefaultQueryParams(additionalParams = {}) {
  const currentErrand = store.getters.currentErrand
  const paramData = { channel: _.get(currentErrand, 'channel'), accessGroup: _.get(currentErrand, 'access_group'), requestId: _.get(currentErrand, 'request_id'), isoCode: localizationService.getCurrentIsoCode(), backendSystem: _.get(currentErrand, 'backend_system') }
  const definedParams = _.pickBy(paramData, _.identity)
  return $.param(_.merge({}, definedParams, additionalParams))
}

function get(path, data = {}, settings = {}) {
  const mergedSettings = _.merge({}, {
    url: getUrlWithQueryParams(path),
    data: data
  }, settings)

  return ajax(mergedSettings)
}

function put() {
  return sendJsonContent(...arguments, 'PUT')
}

function post() {
  return sendJsonContent(...arguments, 'POST')
}

function deleteEntity() {
  return sendJsonContent(...arguments, 'DELETE')
}

function postAuth(data) {
  return ajax({
    url: getUrlWithQueryParams('oauth/token'),
    data: data,
    type: 'POST'
  })
}

function sendJsonContent(path, data = {}, type) {
  return ajax({
    url: getUrlWithQueryParams(path),
    data: JSON.stringify(data),
    type: type,
    contentType: 'application/json; charset=utf-8'
  })
}

function uploadFiles(path, files) {
  const formData = new FormData()
  files.forEach(async (file, index) => {
    formData.append(`file${index}`, file, file.name)
  })

  return ajax({
    type: 'POST',
    url: getUrlWithQueryParams(path),
    data: formData,
    contentType: false,
    processData: false,
    timeout: 60000
  })
}

export default {
  baseUrl,
  getDefaultQueryParams,
  get,
  put,
  post,
  postAuth,
  uploadFiles,
  delete: deleteEntity
}
